import { produce } from "immer";
import {
  FETCH_CARE_ROUND_TYPE,
  FETCH_CARE_ROUND_TYPE_SUCCESS,
  FETCH_CARE_ROUND_TYPE_FAILURE,
  SEARCH_CARE_ROUND_TYPE,
  SEARCH_CARE_ROUND_TYPE_SUCCESS,
  SEARCH_CARE_ROUND_TYPE_FAILURE,
  ADD_CARE_ROUND_TYPE,
  ADD_CARE_ROUND_TYPE_SUCCESS,
  ADD_CARE_ROUND_TYPE_FAILURE,
  FETCH_CARE_ROUND_TYPE_ITEM,
  FETCH_CARE_ROUND_TYPE_ITEM_SUCCESS,
  FETCH_CARE_ROUND_TYPE_ITEM_FAILURE,
  EDIT_CARE_ROUND_TYPE,
  EDIT_CARE_ROUND_TYPE_SUCCESS,
  EDIT_CARE_ROUND_TYPE_FAILURE,
  DELETE_CARE_ROUND_TYPE,
  DELETE_CARE_ROUND_TYPE_SUCCESS,
  DELETE_CARE_ROUND_TYPE_FAILURE,
  SET_CARE_ROUND_TYPE_ADD_EDIT_MODAL,
} from "./constants";

export const initialState = {
  careRoundTypeList: [],
  careRoundTypeSearchList: [],
  currentCareRoundType: null,
  careRoundTypeTotal: 0,
  isFetchingCareRoundType: false,
  isSearchingCareRoundType: false,
  isSubmittingCareRoundType: false,
  isDeletingCareRoundType: false,
  careRoundTypeAddEditModal: { open: false, isEditing: false, item: null },
};

const CareRoundTypeReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case FETCH_CARE_ROUND_TYPE: {
        draft.isFetchingCareRoundType = true;
        const page = action.payload?.page;
        if (page === 1 || page == null) {
          draft.careRoundTypeList = [];
        }
        break;
      }
      case FETCH_CARE_ROUND_TYPE_SUCCESS: {
        draft.isFetchingCareRoundType = false;
        const payload = action.payload;
        const p = payload?.current_page ?? 1;
        if (p === 1) {
          draft.careRoundTypeList = payload;
        } else {
          const prevData = Array.isArray(draft.careRoundTypeList?.data)
            ? draft.careRoundTypeList.data
            : [];
          const nextData = Array.isArray(payload?.data) ? payload.data : [];
          draft.careRoundTypeList = {
            ...payload,
            data: [...prevData, ...nextData],
            current_page: p,
          };
        }
        draft.careRoundTypeTotal =
          payload?.total ?? draft.careRoundTypeTotal ?? 0;
        break;
      }
      case FETCH_CARE_ROUND_TYPE_FAILURE:
        draft.isFetchingCareRoundType = false;
        draft.careRoundTypeList = [];
        break;

      case SEARCH_CARE_ROUND_TYPE:
        draft.isSearchingCareRoundType = true;
        draft.careRoundTypeSearchList = [];
        break;
      case SEARCH_CARE_ROUND_TYPE_SUCCESS:
        draft.isSearchingCareRoundType = false;
        draft.careRoundTypeSearchList = Array.isArray(action.payload)
          ? action.payload
          : [];
        break;
      case SEARCH_CARE_ROUND_TYPE_FAILURE:
        draft.isSearchingCareRoundType = false;
        draft.careRoundTypeSearchList = [];
        break;

      case ADD_CARE_ROUND_TYPE:
        draft.isSubmittingCareRoundType = true;
        break;
      case ADD_CARE_ROUND_TYPE_SUCCESS:
        draft.isSubmittingCareRoundType = false;
        break;
      case ADD_CARE_ROUND_TYPE_FAILURE:
        draft.isSubmittingCareRoundType = false;
        break;

      case FETCH_CARE_ROUND_TYPE_ITEM:
        draft.isFetchingCareRoundType = true;
        draft.currentCareRoundType = null;
        break;
      case FETCH_CARE_ROUND_TYPE_ITEM_SUCCESS:
        draft.isFetchingCareRoundType = false;
        draft.currentCareRoundType = action.payload;
        break;
      case FETCH_CARE_ROUND_TYPE_ITEM_FAILURE:
        draft.isFetchingCareRoundType = false;
        draft.currentCareRoundType = null;
        break;

      case EDIT_CARE_ROUND_TYPE:
        draft.isSubmittingCareRoundType = true;
        break;
      case EDIT_CARE_ROUND_TYPE_SUCCESS:
        draft.isSubmittingCareRoundType = false;
        break;
      case EDIT_CARE_ROUND_TYPE_FAILURE:
        draft.isSubmittingCareRoundType = false;
        break;

      case DELETE_CARE_ROUND_TYPE:
        draft.isDeletingCareRoundType = true;
        break;
      case DELETE_CARE_ROUND_TYPE_SUCCESS:
        draft.isDeletingCareRoundType = false;
        break;
      case DELETE_CARE_ROUND_TYPE_FAILURE:
        draft.isDeletingCareRoundType = false;
        break;

      case SET_CARE_ROUND_TYPE_ADD_EDIT_MODAL:
        draft.careRoundTypeAddEditModal = {
          open: action.payload?.open ?? false,
          isEditing: action.payload?.isEditing ?? false,
          item: action.payload?.item ?? null,
        };
        break;

      default:
        break;
    }
  });

export default CareRoundTypeReducer;
